import React from "react";
var __jsx = React.createElement;
import { AffiliationBlockType } from '@uno/common-cms';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { Container } from './AffiliationBlock.style';
import AffiliationBlockCta from './AffiliationBlockCta/AffiliationBlockCta';
import AffiliationBlockPriceTable from './AffiliationBlockPriceTable/AffiliationBlockPriceTable';
import AffiliationBlockSlideshow from './AffiliationBlockSlideshow/AffiliationBlockSlideshow';

var AffiliationBlock = function AffiliationBlock(_ref) {
  var block = _ref.block,
      editorState = _ref.blockProps.editorState;

  var _useGetBlockData = useGetBlockData(editorState, block.getKey(), block.getEntityAt(0)),
      entityData = _useGetBlockData.entityData;

  var renderBlock = function renderBlock() {
    switch (entityData.type) {
      case AffiliationBlockType.Cta:
        return __jsx(AffiliationBlockCta, {
          entityData: entityData
        });

      case AffiliationBlockType.PriceTable:
        return __jsx(AffiliationBlockPriceTable, {
          entityData: entityData
        });

      case AffiliationBlockType.Slideshow:
        return __jsx(AffiliationBlockSlideshow, {
          entityData: entityData
        });

      default:
        return null;
    }
  };

  return __jsx(Container, null, renderBlock());
};

export default AffiliationBlock;